import React from "react";

//libraries
import { Helmet } from "react-helmet-async";

//styles
import "./ContactScreen.scss";

//components
import ContactForm from "../Contact/ContactForm/ContactForm.jsx";

//content
import contactcontent from "./contactcontent.js";

const ContactScreen = () => {
  return (
    <>
      <Helmet>
        <title>
          Contact Concierge Wellness | Physical Therapy & Massage Therapy
        </title>

        <meta
          name="description"
          content="Contact Concierge Wellness in Colorado Springs to schedule physical therapy or massage therapy services. Reach out with questions or book your consultation today."
        />

        <meta name="robots" content="index,follow" />

        <link rel="canonical" href="https://conciergewellnesspt.com/contact" />

        <meta property="og:title" content="Contact Concierge Wellness" />

        <meta
          property="og:description"
          content="Contact Concierge Wellness in Colorado Springs for physical therapy and massage therapy services."
        />

        <meta
          property="og:url"
          content="https://conciergewellnesspt.com/contact"
        />

        <meta property="og:type" content="website" />

        <meta
          property="og:image"
          content="https://conciergewellnesspt.com/icon.png"
        />
      </Helmet>
      <main className="contact">
        <div className="image-container"></div>
        <div className="contact-text">
          <div className="centered-text">
            <p>{contactcontent.blurb}</p>
          </div>
        </div>
        <ContactForm />
      </main>
    </>
  );
};

export default ContactScreen;
